import * as React from "react"
import {Box, Chip, Grid, Typography} from "@mui/material";
import {CheckboxSeeker} from "@ui-seeker/core";
import {MatchersLazyImage} from "../../@components";

import {BACKEND_APIS} from "@constants";
import SkuAttributesBlock from "../@components/SkuAttributesBlock";
import {matcherSKUImageComparatorModalData} from "../@signals";


// Memoised: the selection is a signal the whole page reads, so every change re-rendered the
// complete candidate list (hundreds of cards for a big brand). With `isSelected` as a boolean
// prop only the two cards that change re-render. Same fix as the Raw matcher (869fkbgeq).
function ProductOption({ skuID, isSelected=false, data, targetImage, setSelectedSKU, brandOptionsIndex=0, isIAOption=false }) {
	const border = isSelected ? "4px solid" : '1px solid'

	const handleCheck = () => setSelectedSKU(isSelected ? null : skuID)

	return <Grid item xs={12}><Grid container border={border} borderColor="primary.light" borderRadius={1} p={.5} pt={0} cursor="pointer" spacing={2} onClick={handleCheck}>

		<Grid item xs={2} display="flex" justifyContent="center">
			<CheckboxSeeker label="" checked={isSelected} onChange={handleCheck} sx={{ mx: 0 }} />

			<MatchersLazyImage
				useSpinner
				src={`${BACKEND_APIS.BACKEND}/sku/image/${skuID}`}
				sx={{ border: '1px solid', borderColor: 'divider', width: 150, height: 'auto', maxHeight: 200, cursor: 'pointer' }}
				onClick={() => matcherSKUImageComparatorModalData.value = {
					title: data.sku,
					urlLeft: targetImage,
					fullUrlRight: `${BACKEND_APIS.BACKEND}/sku/image/${skuID}`,
					targetIndex: brandOptionsIndex
				}}
			/>
		</Grid>

		<Grid item xs={10} display="flex" flexDirection="column" justifyContent="center">
			<Box display="flex" justifyContent="space-between">
				<Typography>
					{data.sku}
				</Typography>

				{ !!isIAOption && <Chip
					label={"IA Candidate" + (data.AIDistance ? ` (${data.AIDistance})` : '')}
					color="primary"
					sx={{ minWidth: 130, height: 24 }}
				/> }
			</Box>
			<Typography color="text.disabled">
				Line: {data.line}
			</Typography>
			<Typography color="text.disabled">
				EAN: {data.ean}
			</Typography>
			<Typography color="text.disabled">
				Ref.: {data.reference}
			</Typography>
			<Typography color="text.disabled">
				Brand: {data.brand}
			</Typography>
		</Grid>

		<Grid item xs={12}>
			<SkuAttributesBlock skuID={data.skuID} />
		</Grid>
	</Grid></Grid>
}

export default React.memo(ProductOption)
